module.exports = __webpack_public_path__ + "img/placeholder-timeline.3f57ff21.png";